window.bindToolTip = () => {
    $(".tool-tip-item").tooltip();
}